module.exports = __webpack_public_path__ + "static/the-rise-of-superman-43273736b5c2939763ed833faca0c998.jpg";